// removed by extract-text-webpack-plugin
module.exports = {"title":"title--3zZ1L","list":"list--2OWRV","listItemLink":"listItemLink--IH135","listItem":"listItem--2ZXxr","icon":"icon--21pJH"};